import "@/styles/components/shared/loader.scss";

export default function Loader({
  color,
  height,
  width,
}: {
  color: string;
  height: string;
  width: string;
}) {
  const loadingExternalStyle = {
    width: `${width}px`,
    height: `${height}px`,
  };
  const animationContainerStyle = {
    width: `${width}px`,
    height: `${height}px`,
    top: `${+width / 2}px`,
    left: `${+height / 2}px`,
  };

  return (
    <div className="loading_external" style={loadingExternalStyle}>
      <div className="loading_internal">
        <div
          className={`animation_container ${color}`}
          style={animationContainerStyle}
        />
      </div>
    </div>
  );
}
